import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { formatCompact, formatMoney } from "./usageFormatters";

const METRICS = {
    estimated_cost_usd: { label: "Costo USD", formatter: formatMoney },
    total_tokens: { label: "Tokens", formatter: formatCompact },
    requests: { label: "Requests", formatter: formatCompact },
};

function bucketLabel(value) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return new Intl.DateTimeFormat("es-EC", { day: "2-digit", month: "short", hour: date.getHours() ? "2-digit" : undefined }).format(date);
}

export default function UsageTimeseries({ items = [], metric, onMetricChange }) {
    const config = METRICS[metric] || METRICS.estimated_cost_usd;
    return (
        <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
            <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div>
                    <h2 className="font-semibold text-slate-900">Consumo en el tiempo</h2>
                    <p className="mt-0.5 text-xs text-slate-500">Evolución agregada de todas las aplicaciones</p>
                </div>
                <Select value={metric} onValueChange={onMetricChange}>
                    <SelectTrigger className="w-full sm:w-40"><SelectValue /></SelectTrigger>
                    <SelectContent>{Object.entries(METRICS).map(([key, value]) => <SelectItem key={key} value={key}>{value.label}</SelectItem>)}</SelectContent>
                </Select>
            </div>
            <div className="h-72 w-full">
                {items.length ? (
                    <ResponsiveContainer width="100%" height="100%">
                        <AreaChart data={items} margin={{ top: 8, right: 10, left: 0, bottom: 0 }}>
                            <defs>
                                <linearGradient id="aiUsageFill" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor="#f97316" stopOpacity={0.28} />
                                    <stop offset="95%" stopColor="#f97316" stopOpacity={0.02} />
                                </linearGradient>
                            </defs>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
                            <XAxis dataKey="bucket" tickFormatter={bucketLabel} tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} minTickGap={24} />
                            <YAxis tickFormatter={config.formatter} tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} width={64} />
                            <Tooltip labelFormatter={bucketLabel} formatter={(value) => [config.formatter(value), config.label]} contentStyle={{ borderRadius: 10, borderColor: "#e2e8f0" }} />
                            <Area type="monotone" dataKey={metric} stroke="#f97316" strokeWidth={2} fill="url(#aiUsageFill)" />
                        </AreaChart>
                    </ResponsiveContainer>
                ) : <div className="flex h-full items-center justify-center text-sm text-slate-400">Todavía no hay consumo en este período.</div>}
            </div>
        </section>
    );
}
